// extracted by mini-css-extract-plugin
export default {"numberInput":"login_numberInput__3uMCg","sendOtpTick":"login_sendOtpTick__ZoqtV","otpContainer":"login_otpContainer__MoeNS","otpInput":"login_otpInput__zY4qh"};